import React, { Component } from "react";
import { Row, Col, Table } from "antd";
import moment from "moment";

import "./Order.css";

class PrintRequisitionSheet extends Component {
  state = {
    taskData: [
      {
        id: "1",
        task:
          "Pharmacy Billing + Dispatch",
        responsibility: "",
        by: "",
      },
      {
        id: "2",
        task: "Pre-pack quantity + expiry check",
        responsibility: "",
        by: "",
      },
      {
        id: "3",
        task: "QC L3",
        responsibility: "",
        by: "",
      },
      {
        id: "4",
        task: "QC L2",
        responsibility: "",
        by: "",
      },
      {
        id: "5",
        task: "QC L1",
        responsibility: "",
        by: "",
      },
      {
        id: "6",
        task: "Dispenser Box QC",
        responsibility: "",
        by: "",
      },
      {
        id: "7",
        task: "Dispatch",
        responsibility: "",
        by: "",
      },
    ],
  };

  render() {
    const { taskData } = this.state;

    const {
      generateData,
      info,
      refillStartDate,
      refillDuration,
      address,
      doctor,
      discount,
      startDate,
    } = this.props;

    // console.log(generateData.length);

    const taskColumn = [
      {
        title: "S No",
        dataIndex: "id",
        align: "left",
        width: 20,
        className: "indColumn",
      },
      {
        title: "TASK",
        dataIndex: "task",
        align: "left",
        width: 250,
        className: "indColumn",
      },
      {
        title: "RESPONSIBILITY",
        dataIndex: "responsibility",
        align: "left",
        className: "indColumn",
      },
      {
        title: "SIGNATURE",
        dataIndex: "by",
        align: "left",
        className: "indColumn",
      },
    ];

    const column = [
      {
        title: "Medicine",
        dataIndex: "name",
        align: "left",
        width: 150,
        className: "indColumn",
      },
      {
        title: "Need",
        dataIndex: "total_quantity",
        align: "left",
        width: 60,
        className: "indColumn",
      },
      // {
      //     title: 'Exp',
      //     dataIndex: 'expiry',
      //     align: 'left',
      //     width: 40,
      //     className: 'indColumn',
      // },
      // {
      //     title: 'Partner',
      //     dataIndex: 'partner',
      //     align: 'left',
      //     width: 50,
      //     className: 'indColumn',
      // },
      // {
      //     title: 'CD',
      //     dataIndex: 'caredose',
      //     align: 'left',
      //     width: 50,
      //     className: 'indColumn',
      // },
      {
        title: "CID",
        dataIndex: "",
        align: "left",
        width: 70,
        className: "indColumn",
      },
      {
        title: "Comments",
        dataIndex: "",
        width: 200,
        align: "center",
        className: "indColumn",
      },
    ];

    return (
      <div id="print-requisition-content" style={{ display: "none" }}>
        <Row type="flex" justify="center">
          <Col span={12}>
            <div style={{ textAlign: "center", fontSize: "10px" }}>
              <Row type="flex" justify="space-around">
                <Col span={8}>
                  <p style={{ color: "black" }}>Order id - {info.id}</p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Patient Name -{" "}
                    {info.user === undefined
                      ? null
                      : `${info.user.first_name} ${info.user.last_name}`}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Location -{" "}
                    {info.partner === undefined
                      ? null
                      : `${info.partner_location.name}`}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Start Date - {moment(refillStartDate).format("DD-MM-YYYY")}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Refill Tenure - {refillDuration} Days
                  </p>
                </Col>
              </Row>

              <Row type="flex" justify="space-around" span={12}>
                <Col span={8}>
                  <p style={{ color: "black" }}>
                    packaging Date -
                    {moment(startDate).subtract(3, "days").format("DD-MM-YYYY")}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Discount -{discount === "" ? "" : `${discount}%`}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>Doctors - {doctor}</p>
                </Col>
              </Row>

              <Row type="flex" justify="space-around" span={12}>
                <Col span={8}>
                  <p style={{ color: "black" }}>Address - {address}</p>
                </Col>
              </Row>
            </div>

            <Table
              pagination={false}
              dataSource={generateData}
              columns={column}
              className="printHead"
              rowClassName="printColumn"
              rowKey="id"
              bordered
              size="small"
              style={{ outline: "1px solid black" }}
            />

            <Row type="flex" justify="space-between">
              <Col style={{ color: "black" }}>Rider - .....</Col>
              <Col style={{ color: "black" }}>Partner Disp. - .....</Col>
              <Col style={{ color: "black" }}>Caredose Disp. - .....</Col>
              <Col style={{ color: "black" }}>Inventorised By - .....</Col>
            </Row>
          </Col>

          <Col span={12}>
            <div style={{ textAlign: "center", fontSize: "10px" }}>
              <Row type="flex" justify="space-around">
                <Col span={8}>
                  <p style={{ color: "black" }}>Order - {info.id}</p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Patient Name -{" "}
                    {info.user === undefined
                      ? null
                      : `${info.user.first_name} ${info.user.last_name}`}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Partner Name -{" "}
                    {info.partner === undefined
                      ? null
                      : `${info.partner_location.name}`}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Start Date - {moment(refillStartDate).format("DD-MM-YYYY")}
                  </p>
                </Col>

                <Col span={8}>
                  <p style={{ color: "black" }}>
                    Refill Tenure - {refillDuration} Days
                  </p>
                </Col>
              </Row>
            </div>

            <br />

            <h6 style={{ textAlign: "center" }}>Task Sheet </h6>

            <br />

            <Table
              pagination={false}
              dataSource={taskData}
              columns={taskColumn}
              className="printHead"
              rowClassName="printColumn"
              rowKey="id"
              bordered
              size="small"
              style={{ outline: "1px solid black" }}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default PrintRequisitionSheet;



// WEBPACK FOOTER //
// ./src/component/FetchOrderList/PrintRequisitionSheet.js